const ctx = 'scoped-bus-' + crypto.randomUUID()

const injected_ctx = 'injected-' + ctx


export default {
  data() {
    return {
      __scoped_bus_listeners: new Map()
    }
  },
  provide(){
    return {
      [ctx]: this._scopedBusEmit
    }
  },
  inject: {
    [injected_ctx]: {
      from: ctx,
      default: undefined
    }
  },
  methods: {
    _scopedBusEmit(event, ...args){
      const listener = this.__scoped_bus_listeners.get(event)
      if (listener?.handler) {
        if (listener.options.once) {
          this.__scoped_bus_listeners.delete(event)
        }
        listener.handler(...args)
        return
      }

      this.$dispatch(event, ...args)
    },
    $listen(event, handler, options = {}) {
      this.__scoped_bus_listeners.set(event, {handler, options})
    },
    $dispatch(event, ...args) {
      const emitter = this[injected_ctx]
      if (typeof emitter === 'function') {
        emitter(event, ...args)
      }
    }
  },
  beforeUnmount() {
    this.__scoped_bus_listeners.clear()
  }
}